// extracted by mini-css-extract-plugin
var _1 = "reactivate-button_confirmReactivate__BtEmR";
export { _1 as "confirmReactivate" }
